export default __webpack_public_path__ + "packs/static/media/loader.48319f53.gif";